import { Component, OnInit, Inject } from '@angular/core';
import { BillingReportTypeFilter } from '../../../model/billing/billing-report-type-filter';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BillingReportService } from '../../../services/billing/billing-report.service';

@Component({
  selector: 'app-billing-report-type-dialog',
  templateUrl: './billing-report-type-dialog.component.html',
  styles: []
})
export class BillingReportTypeDialogComponent implements OnInit {

  billingReportTypeFilters: BillingReportTypeFilter[] = [];
  form: FormGroup;
  loading: boolean;

  constructor(public dialogRef: MatDialogRef<BillingReportTypeDialogComponent>,
    private formBuilder: FormBuilder,
    private billingReportService: BillingReportService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.form = this.formBuilder.group({
        billingReportType: ['', Validators.required]
      });
    }

  get f() { return this.form.controls; }

  async ngOnInit() {
    this.loading = true;
    this.billingReportTypeFilters = await this.billingReportService
      .getBillingReportTypeFilters();
    this.loading = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  accept() {
    if ( this.form.valid ) {
      this.dialogRef.close(this.form.getRawValue().billingReportType.id);
    }
  }
}
